import { useEffect } from "react";

import { playNotificationSound } from "@/notification/playNotificationSound";
import { sdkEventBus } from "@/sdk";

/**
 * Plays the disconnect chime when the customer's leg drops unexpectedly on a voice call.
 *
 * The provider SDK owns the (Connect-specific) detection and emits `call_customer_dropped`; this
 * hook is the single place that turns that event into the audible chime, keeping the sound side
 * effect in the UI layer rather than in the provider adapter.
 */
export const useCallDisconnectedChime = () => {
    useEffect(() => {
        const unsubscribe = sdkEventBus.on("call_customer_dropped", () => {
            void playNotificationSound("callDisconnected");
        });

        return unsubscribe;
    }, []);
};
